import router from './router'

router.beforeEach((to, from, next) => {
  let windowTitleObj = {
    'business-open-shop': '商家开店',
    'subcontractor-registration': '分包商注册',
    'index': '注册'
  }
  let url = to.fullPath.split('/')[1]
  if (windowTitleObj[url]) {
    document.title = windowTitleObj[url]
  }
  next()
})
